import axios from "axios";
import { API_ROOT } from ".";
import { getAuthUser } from "./auth";
import type { SubscriptionTier } from "./tiers";

const SUBSCRIPTIONS_API_URL = `${API_ROOT}/subscriptions`;

function getAuthHeaders(): { Authorization: string } {
  const token = getAuthUser()?.token;
  if (!token) throw new Error("Not authenticated");
  return { Authorization: `Bearer ${token}` };
}

export interface Subscription {
  id: string;
  name: string;
  spots?: number;
  isCombo?: boolean;
  isActive?: boolean;
  tiers: SubscriptionTier[];
  /** Total pickups (accounts) with any tier in this subscription. Set when returned from GET /api/subscriptions. */
  spotsTaken?: number;
}

export async function callFetchSubscriptions(): Promise<Subscription[]> {
  const token = getAuthUser()?.token;
  const res = await axios.get<Subscription[]>(SUBSCRIPTIONS_API_URL, {
    ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
  });
  return Array.isArray(res.data) ? res.data : [];
}

export async function callCreateSubscription(data: {
  name: string;
  spots?: number;
  isCombo?: boolean;
}): Promise<Subscription> {
  const res = await axios.post<Subscription>(SUBSCRIPTIONS_API_URL, data, {
    headers: getAuthHeaders(),
  });
  return res.data;
}

export async function callUpdateSubscription(
  id: string,
  data: {
    name?: string;
    spots?: number;
    isCombo?: boolean;
    isActive?: boolean;
  },
): Promise<Subscription> {
  const res = await axios.put<Subscription>(
    `${SUBSCRIPTIONS_API_URL}/${id}`,
    data,
    {
      headers: getAuthHeaders(),
    },
  );
  return res.data;
}

export async function callDeleteSubscription(id: string): Promise<void> {
  await axios.delete(`${SUBSCRIPTIONS_API_URL}/${id}`, {
    headers: getAuthHeaders(),
  });
}
